export function canonicalPrimitiveUserMessageText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function primitiveTimestampMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  return 0;
}

export function getPrimitiveUserMessageText(primitive) {
  return canonicalPrimitiveUserMessageText(primitive?.userMessageText);
}

export function isPrimitiveActive(primitive, nowMs = Date.now()) {
  if (!primitive || primitive.status !== 'active') return false;
  const expiresAtMs = primitiveTimestampMillis(primitive.expiresAt);
  return expiresAtMs > nowMs;
}

function comparePrimitives(a, b) {
  const orderA = Number.isFinite(a.displayOrder) ? a.displayOrder : 999;
  const orderB = Number.isFinite(b.displayOrder) ? b.displayOrder : 999;
  if (orderA !== orderB) return orderA - orderB;
  const createdDiff =
    primitiveTimestampMillis(a.createdAt) - primitiveTimestampMillis(b.createdAt);
  if (createdDiff !== 0) return createdDiff;
  return String(a.id).localeCompare(String(b.id));
}

export function selectInteractionPrimitiveView(primitives = [], nowMs = Date.now()) {
  const active = primitives
    .filter(
      (primitive) =>
        isPrimitiveActive(primitive, nowMs) && getPrimitiveUserMessageText(primitive)
    )
    .sort(comparePrimitives);
  const starterPrimitives = active.filter((primitive) => primitive.phase === 'starter');
  const replyPrimitivesByAnchorId = new Map();

  for (const primitive of active) {
    if (primitive.phase !== 'reply') continue;
    const anchorId = primitive.placement?.anchor?.id;
    if (!anchorId) continue;
    const current = replyPrimitivesByAnchorId.get(anchorId) || [];
    current.push(primitive);
    replyPrimitivesByAnchorId.set(anchorId, current);
  }

  return {
    starterPrimitives,
    replyPrimitivesByAnchorId,
  };
}

// Callable error codes the server uses to reject the tapped primitive itself
// (missing, invalid, expired). Anything else — unavailable, deadline,
// internal, plain network errors — is a transport failure and says nothing
// about the displayed set's freshness.
const PRIMITIVE_REJECTION_CODES = new Set([
  'functions/not-found',
  'functions/invalid-argument',
  'functions/failed-precondition',
]);

export function isPrimitiveRejectionError(error) {
  return PRIMITIVE_REJECTION_CODES.has(error?.code);
}

export function preflightPrimitiveTap(primitive, nowMs = Date.now()) {
  if (!isPrimitiveActive(primitive, nowMs)) {
    return {
      ok: false,
      reason: 'unavailable',
    };
  }
  const text = getPrimitiveUserMessageText(primitive);
  if (!text) {
    return {
      ok: false,
      reason: 'empty',
    };
  }

  return {
    ok: true,
    text,
    primitiveId: primitive.id,
  };
}
